import { useCallback } from 'react';

import { useDebouncedCallback } from 'use-debounce';

import { useAnalytics } from './use-analytics';

/**
 * Returns a callback which fires an editionAwareness dialog closed event
 */
export const useOnCloseDialog = () => {
	const { sendAnalyticsEvent } = useAnalytics();

	const onClose = useCallback(
		(attributes?: Record<string, unknown>) => {
			sendAnalyticsEvent({
				action: 'closed',
				actionSubject: 'dialog',
				actionSubjectId: 'editionAwarenessDialog',
				attributes,
			});
		},
		[sendAnalyticsEvent],
	);

	const [onCloseDebounced] = useDebouncedCallback(onClose, 300, {
		leading: true,
		trailing: false,
	});

	return onCloseDebounced;
};
